/**
 * Container for wrapping a Select for custom styling
 *
 */

import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import Select from '../Select';

class SelectWrapper extends Component {
  render() {
    const {
      className,
      theme,
      isMobile,
      ariaLabel,
      ...others
    } = this.props;

    const wrapperTheme = theme && theme.selectWrapper;
    const selectWrapperClass = wrapperTheme ? wrapperTheme.wrapper : wrapperTheme;
    const deviceFlags = { isMobile };

    return (
      <div className={classNames(selectWrapperClass, deviceFlags, className)} aria-label={ariaLabel}>
        <Select isMobile={isMobile} theme={theme} {...others} />
      </div>
    );
  }
}

SelectWrapper.propTypes = {
  className: PropTypes.string,
  isMobile: PropTypes.bool,
  theme: PropTypes.object
};

SelectWrapper.defaultProps = {
  theme: {
    selectWrapper: {
      wrapper: {}
    }
  }
};

export default SelectWrapper;



/** WEBPACK FOOTER **
 ** ./src/components/SelectWrapper/index.js
 **/